export const stores = [
  "Spotify",
  "Apple Music",
  "iTunes",
  "Instagram & Facebook",
  "TikTok, Resso & Luna",
  "YouTube Music",
  "Amazon",
  "Soundtrack by Twitch",
  "Pandora",
  "Deezer",
  "Tidal",
  "iHeartRadio",
  "ClaroMusica",
  "Saavn",
  "Boomplay",
  "Anghami",
  "KKBox",
  "NetEase",
  "Tencnet",
  "Qobuz (beta)",
  "Joox",
  "Kuack Media",
  "Yandex Music (beta)",
  "Adaptr",
  "Flo",
  "MediaNet",
  "Snapchat",
  "Audiomack",
  "Triller",
  "SouncCloud",
  "Shazam"
];
